import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";

const faqs = [
    {
        q: "Berapa biaya pembuatan website?",
        a: "Biaya menyesuaikan kompleksitas. Website profil mulai dari kelas UMKM hingga sistem khusus (showroom + admin, travel, dll). Cara paling cepat: chat WhatsApp kami, cerita kebutuhan anda, kami beri estimasi terbuka di awal.",
    },
    {
        q: "Apakah saya bisa update isi website sendiri?",
        a: "Bisa. Untuk paket dengan admin panel (mis. showroom mobil bekas), anda bisa update stok, harga, dan foto kapan saja. Kami juga sediakan training singkat saat launching.",
    },
    {
        q: "Berapa lama proses pengerjaannya?",
        a: "Website profil sederhana umumnya 4–7 hari. Sistem dengan admin panel atau katalog kompleks bisa 2–4 minggu, tergantung fitur dan kecepatan revisi.",
    },
    {
        q: "Apakah sudah termasuk domain dan hosting?",
        a: "Bisa kami bantu pengadaan domain dan hosting, atau jika anda sudah punya, tinggal kami konfigurasi. Kami akan jelaskan biaya tahunannya secara transparan.",
    },
    {
        q: "Bagaimana setelah website jadi? Ada layanan maintenance?",
        a: "Ada. Kami sediakan paket maintenance bulanan untuk backup rutin, update keamanan, perbaikan minor, dan support via WhatsApp.",
    },
    {
        q: "Apakah hanya melayani klien di Jayapura?",
        a: "Tidak. Studio kami di Abepura, tapi kami melayani klien dari seluruh Indonesia. Komunikasi bisa via WhatsApp dan online meeting.",
    },
];

export const FAQ = () => {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="py-20 md:py-32"
        >
            <div className="max-w-6xl mx-auto px-5 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
                    <div className="col-span-1 md:col-span-5">
                        <div className="text-xs uppercase tracking-[0.3em] text-jws-muted mb-4">
                            (06) FAQ
                        </div>
                        <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[1]">
                            Pertanyaan
                            <br />
                            yang sering
                            <br />
                            <span className="italic text-jws-primary">
                                muncul
                            </span>
                            .
                        </h2>
                    </div>
                    <div className="col-span-1 md:col-span-7">
                        <Accordion type="single" collapsible className="w-full">
                            {faqs.map((f, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    data-testid={`faq-item-${i}`}
                                    className="border-b border-jws-border"
                                >
                                    <AccordionTrigger className="text-left font-display text-lg md:text-2xl tracking-tight py-6 hover:no-underline">
                                        {f.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-jws-muted text-base leading-relaxed pb-6 pr-6">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
};
